import { z } from 'zod';
import {
    PortfolioBookablePeriod,
    PortfolioCancellationFeeExtent,
    PortfolioCancellationPolicyApplicability,
} from '@mews-commander/data-access';
import { MAX_SMALL_INPUT_TEXT_LENGTH } from '@mews-commander/constants';
import {
    CancellationPolicyFormField,
    baseValidationSchema,
    transformApplicabilityOffset,
} from '../../cancellationPolicies';
import { CancellationFeeExtentFieldOption } from './types';

export const validationSchema = baseValidationSchema
    .extend({
        [CancellationPolicyFormField.Key]: z.string().min(1).max(MAX_SMALL_INPUT_TEXT_LENGTH),
        [CancellationPolicyFormField.Applicability]: z.nativeEnum(PortfolioCancellationPolicyApplicability),
        [CancellationPolicyFormField.BookablePeriod]: z.nativeEnum(PortfolioBookablePeriod),
        [CancellationPolicyFormField.FeeExtent]: z.nativeEnum(CancellationFeeExtentFieldOption).transform((value) => {
            switch (value) {
                case CancellationFeeExtentFieldOption.TimeUnits:
                    return [PortfolioCancellationFeeExtent.TimeUnits];
                case CancellationFeeExtentFieldOption.Products:
                    return [PortfolioCancellationFeeExtent.Products];
                case CancellationFeeExtentFieldOption.TimeUnitsAndProducts:
                    return [PortfolioCancellationFeeExtent.TimeUnits, PortfolioCancellationFeeExtent.Products];
            }
        }),
    })
    .transform(transformApplicabilityOffset);

export type FormValues = z.input<typeof validationSchema>;
